import React from 'react';
import Chip from '@mui/material/Chip';

function LineBadge({ lineName, color, textColor, size = 'small', sx = {}, labelPrefix }) {
  const label = labelPrefix ? `${labelPrefix} ${lineName}` : lineName;
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: color || '#667eea',
        color: textColor || '#fff',
        fontWeight: 800,
        fontSize: 11,
        ...sx,
      }}
    />
  );
}

export default LineBadge;
